import { Img, Text, Heading } from "../../components";
import React from "react";

export default function AboutMe() {
  return (
    <section id="aboutme" className="container-xs flex justify-center min-h-screen">
      <div className="mt-[98px] md:flex-col">
        <div className="mb-[22px] flex flex-col items-start gap-7 md:w-full md:px-5">
          <Heading size="heading2xl" as="h2" className="text-[96px] font-bold text-white-a700 md:text-[48px]">
            <span className="text-white-a700">About me</span>
            <span className="text-orange-a200">.</span>
          </Heading>
          <div className="flex flex-col items-start gap-7 self-stretch">
            <Text
              size="textmd"
              as="p"
              className="w-[94%] text-[36px] font-normal leading-[46px] text-white-a700 md:w-full md:text-[34px] sm:text-[32px]"
            >
              Hi!, I’m Timo 20 years old from the Netherlands. I’ve always been interested in IT since a young age. Started
              making some fun project on Minecraft with friends and eventually decided to make Software Development my
              work.
            </Text>
            <div className="flex rounded-full">
              <img className="rounded-[50px] h-auto w-1/2" src="images/friends.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
